import { Search } from '@mui/icons-material';
import {
  Box,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';

import { ORDER_BY_OPTIONS, ORDER_OPTIONS } from '@/admins/SmartReports/constants';
import { useSmartReportList } from './SmartReportListContext';
import { styles } from './styles';

export const SmartReportListControls = () => {
  const { search, setSearch, orderBy, setOrderBy, order, setOrder } = useSmartReportList();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
      <FormControl sx={styles.search}>
        <TextField
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Filter by smart report name or description"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            },
          }}
        />
      </FormControl>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '24px' }}>
        <FormControl variant="outlined" sx={styles.select}>
          <InputLabel id="order-by">Order by</InputLabel>
          <Select
            value={orderBy}
            onChange={(e) => setOrderBy(e.target.value)}
            labelId="order-by"
            label="Order By"
          >
            {ORDER_BY_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="outlined" sx={styles.select}>
          <InputLabel id="order">Order</InputLabel>
          <Select
            value={order}
            onChange={(e) => setOrder(e.target.value)}
            labelId="order"
            label="Order"
          >
            {ORDER_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};
